import type { ReactElement } from 'react'

import Modal from '~/components/Modal'

interface Props {
  isOpen: boolean
  mediaUrl: string
  onClose: VoidFunction
}

const CatalogTemplatePreviewModal = ({ isOpen, mediaUrl, onClose }: Props): ReactElement => {
  return (
    <Modal className="catalog-template-preview-modal" isOpen={isOpen} onCloseModal={onClose}>
      <img className="catalog-template-preview-modal__drawing" src={mediaUrl} />
    </Modal>
  )
}

export default CatalogTemplatePreviewModal
